(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('multipleFlightsInRollingSevenDays', [
      'ui.router'
    ]);
}());
